import { Text, Group, Switch } from '@mantine/core';

import { ProphetRuleForm } from '../../../hooks/useProphetRuleForm';
import { ChunkPlatform } from '../../../utils/chunk-limits';

import { MessagesFields } from './MessagesFields';

type Props = {
  form: ProphetRuleForm;
  platform: ChunkPlatform;
};
export const Messages = ({ form, platform }: Props) => {
  if (form.values.actions.success.type !== 'reply') {
    return null;
  }
  return (
    <div>
      <Text ta="center" size="md" mt="sm">
        Приветствия
      </Text>
      <MessagesFields
        form={form}
        name="greetings"
        placeholder="Текст приветствия"
        isRequired
        platform={platform}
      />
      <Text ta="center" size="md" mt="sm">
        Текст подготовки
      </Text>
      <MessagesFields
        form={form}
        name="preparing"
        placeholder="Текст подготовки"
        platform={platform}
      />
      <Text ta="center" size="md">
        Расклады
      </Text>
      <MessagesFields
        form={form}
        name="spreads"
        placeholder="Текст расклада"
        isRequired
        platform={platform}
      />
      <Group justify="center" gap="xs" mt="sm">
        <Text ta="center" size="md">
          Пинки после расклада
        </Text>
        <Switch
          color="green"
          checked={form.values.isSpreadKickRequired}
          onChange={(event) =>
            form.setFieldValue('isSpreadKickRequired', event.currentTarget.checked)
          }
          size="xs"
        />
      </Group>
      <MessagesFields
        form={form}
        name="spreadKicks"
        placeholder="Текст пинка"
        isRequired={form.values.isSpreadKickRequired}
        platform={platform}
      />
      <Group justify="center" gap="xs" mt="sm">
        <Text ta="center" size="md">
          Скидки
        </Text>
        <Switch
          color="green"
          checked={form.values.isDiscountRequired}
          onChange={(event) =>
            form.setFieldValue('isDiscountRequired', event.currentTarget.checked)
          }
          size="xs"
        />
      </Group>
      <MessagesFields
        form={form}
        name="discounts"
        placeholder="Текст скидки"
        isRequired={form.values.isDiscountRequired}
        platform={platform}
      />
    </div>
  );
};
